<template>
  <div
    class="flex w-full flex-col text-left"
    :class="margin"
  >
    <label
      class="mb-2 block font-medium text-gray-600 dark:text-gray-300"
      :for="name"
      >{{ title }}
    </label>
    <div class="flex">
      <input
        :id="name"
        autocomplete="off"
        class="focus:border-navy-500 focus:ring-navy-500/50 z-1 block w-full grow rounded-l border px-3 py-2 shadow-xs transition duration-100 ease-in-out placeholder:text-gray-400 focus:ring-2 focus:outline-hidden disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500 disabled:opacity-50"
        :class="errorMessage ? 'border-danger-300 bg-danger-50 text-danger-900 dark:bg-danger-800 dark:text-danger-200' : 'border-gray-300 bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-200'"
        :minlength="minLength"
        :name="name"
        :placeholder="placeholderText"
        :required="required"
        :title="title"
        :type="showPassword ? 'text' : 'password'"
      />
      <div
        class="focus:border-navy-500 focus:ring-navy-500/50 z-1 block shrink cursor-pointer rounded-r border-y border-r px-3 py-2 shadow-xs transition duration-100 ease-in-out placeholder:text-gray-400 focus:ring-2 focus:outline-hidden disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-500 disabled:opacity-50"
        :class="errorMessage ? 'border-danger-300 bg-danger-50 text-danger-900 dark:bg-danger-800 dark:text-danger-200' : 'border-gray-300 bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-200'"
        @click.prevent="showPassword = !showPassword"
      >
        <i
          class="fa-light"
          :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
        />
      </div>
    </div>
    <p
      v-if="errorMessage"
      class="text-danger-500 my-1 text-sm"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="passwordRules"
      class="my-1 text-sm text-gray-500 dark:text-gray-200"
    >
      {{ passwordRules }}
    </p>
  </div>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";

interface Props {
  name: string;
  title?: string;
  required?: boolean;
  placeholder?: string | null;
  minLength?: number;
  passwordRules?: string | null;
  errorMessage?: string | null;
  margin?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  required: true,
  placeholder: null,
  minLength: 3,
  passwordRules: null,
  errorMessage: null,
  margin: "mb-4",
});

const showPassword = ref(false);

const placeholderText = computed((): string => {
  if (props.placeholder) {
    return props.placeholder;
  }
  if (props.title) {
    return props.title;
  }
  return "";
});
</script>
